import React from 'react';
import { Row, Col } from 'react-bootstrap-5';
import type { Office, User } from './types';
import UserTable from './user_table';
import PermissionCard from './permission_card';
import PageBreak from 'components/page_break';
import OfficeSelector from './office_selector';

export type OupMode = 'all' | 'individual' | 'offices';

type OupUserSelectorProps = {
  users: User[];
  officesById: { [key: number]: Office };
  mode: OupMode;
  selectedUserIds: number[];
  selectedOfficeIds: number[];
  onChangeMode: (mode: OupMode) => void;
  onChangeUserIds: (ids: number[]) => void;
  onChangeOfficeIds: (ids: number[]) => void;
}

const OupUserSelector = ({
  users,
  officesById,
  mode,
  selectedUserIds,
  selectedOfficeIds,
  onChangeMode,
  onChangeUserIds,
  onChangeOfficeIds,
}: OupUserSelectorProps) => {
  const showUserSelector = mode === 'individual';

  return (
    <div>
      <h4 className="mb-2">"Other Users" in Permissions refer to</h4>

      <Row className="gy-4">
        <Col sm={6}>
          <PermissionCard
            checked={mode === 'all'}
            label="All Company Users"
            subtitle="This user will be able to manage data for all the users at the company."
            onClick={() => onChangeMode('all')}
          />
        </Col>
        <Col sm={6}>
          <PermissionCard
            checked={mode === 'individual'}
            label="Individual Users"
            subtitle="This user will be able to manage data for the users selected below."
            onClick={() => onChangeMode('individual')}
          />
        </Col>
        <Col sm={6}>
          <PermissionCard
            checked={mode === 'offices'}
            label="Users in Specific Offices"
            subtitle="This user will be able to manage data for users in the specific offices selected below."
            onClick={() => onChangeMode('offices')}
          />
        </Col>
      </Row>

      {showUserSelector && (
        <div className="mt-4">
          <PageBreak label="Select Individual Users" />
          <UserTable
            officesById={officesById}
            selectedUserIds={selectedUserIds}
            users={users}
            onChange={onChangeUserIds}
          />
        </div>
      )}

      <OfficeSelector
        enable={mode === 'offices'}
        officesById={officesById}
        selectedOfficeIds={selectedOfficeIds}
        onChange={onChangeOfficeIds}
      />
    </div>
  );
};

export default OupUserSelector;
